import { FC } from 'react';
import { Box, Button, ButtonAppearance, ButtonProps, ButtonSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { mapHeight } from '~/styled';

export const WeldListTabsContainer = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  mx: { sm: '500' },
  mt: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.spacings[400]};
    overflow-y: hidden;
    margin: 0;
    height: calc(100% - ${mapHeight});
    flex: 1;
    @media only screen and (max-width: ${theme.breakpoints.desktop}) {
      height: 100%;
    }
  `}
`;

export const WeldListTabStyled = styled(Box).attrs({ pt: { sm: '200' }, pl: { sm: '100' } })`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  border-bottom: 1px;
  border-color: ${({ theme }) => theme.colors.grey[300]};
`;
export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}
export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  width: calc(100% / 3);
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};
    padding-left: ${theme.spacings[700]};
    padding-right: ${theme.spacings[700]};
    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;

export const ListStyled = styled.div`
  overflow-y: auto;
  flex-grow: 1;
  height: '100vh';
`;
